<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp"> </p>
<p class="ctfm"><span epub:type="pagebreak" id="pg_vii" title="vii"><span class="ePub-SC">CONTENTS</span></span></p>
<p class="tocfm"><a href="#/xhtml/acknowledgments"><span class="ePub-I">Acknowledgments</span></a></p>
<p class="tocf"><a href="#/xhtml/introduction">Introduction</a></p>
<p class="tocpt"><a href="#/xhtml/part1"><span class="ePub-SC">PART I. THE PROGRESSIVE ERA</span></a></p>
<p class="toc"><a href="#/xhtml/chapter1">1. The Progressive Juvenile Court</a></p>
<p class="tocpt"><a href="#/xhtml/part2"><span class="ePub-SC">PART II. THE DUE PROCESS ERA</span></a></p>
<p class="toc"><a href="#/xhtml/chapter2">2. The Due Process Revolution and the Juvenile Court</a></p>
<p class="tocpt"><span href="#/xhtml/part3" title="Link target outside of Sample"><span class="ePub-SC">PART III. THE GET TOUGH ERA</span></span></p>
<p class="toc"><span href="#/xhtml/chapter3" title="Link target outside of Sample">3. The Get Tough Era I: Structural Change and Youth Crime</span></p>
<p class="toc"><span href="#/xhtml/chapter4" title="Link target outside of Sample">4. The Get Tough Era II: Politics of Race and Crime</span></p>
<p class="toc"><span href="#/xhtml/chapter5" title="Link target outside of Sample">5. The Kid Is a Criminal: Transfer and Delinquency Sanctions</span></p>
<p class="toc"><span href="#/xhtml/chapter6" title="Link target outside of Sample">6. The Girl Is a Criminal: The Impact of Get Tough Policies on Girls</span></p>
<p class="toc"><span href="#/xhtml/chapter7" title="Link target outside of Sample">7. The Student Is a Criminal: Get Tough Policies and the School-to-Prison Pipeline</span></p>
<p class="tocpt"><span href="#/xhtml/part4" title="Link target outside of Sample"><span class="ePub-SC">PART IV. THE KIDS ARE DIFFERENT ERA</span></span></p>
<p class="toc"><span href="#/xhtml/chapter8" title="Link target outside of Sample">8. The Criminal Is a Kid: Adolescents’ Diminished Culpability</span></p>
<p class="toc"><span href="#/xhtml/chapter9" title="Link target outside of Sample">9. The Defendant Is a Kid: Adolescents’ Competence to Exercise Procedural Rights</span></p>
<p class="tocf"><span href="#/xhtml/epilogue" title="Link target outside of Sample">Epilogue: Opportunities and Obstacles</span></p>
<p class="tocbmf"><span href="#/xhtml/notes" title="Link target outside of Sample"><span class="ePub-I">Notes</span></span></p>
<p class="tocbm"><span href="#/xhtml/references" title="Link target outside of Sample"><span class="ePub-I">References</span></span></p>
<p class="tocbm"><span href="#/xhtml/index" title="Link target outside of Sample"><span class="ePub-I">Index</span></span></p>
<p class="tocbm"><span href="#/xhtml/abouttheauthor" title="Link target outside of Sample"><span class="ePub-I">About the Author</span></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?a384b378